import { ROUTE_MENUS } from "../constants/routes";

export default defineNuxtRouteMiddleware((to) => {
  // Check if we're on the menus page and have a navItem query parameter
  if ((to.path === ROUTE_MENUS || to.path === "/menus") && to.query.navItem) {
    let navItem = to.query.navItem as string;
    const query = { ...to.query };

    if (navItem === "heatable-meals") {
      navItem = "kids-meals";
    } else if (navItem === "snacks") {
      navItem = "mighty-bites";
    }

    // Remove the navItem query parameter since we'll use the path instead
    delete query.navItem;

    console.log(`Redirecting from ${to.fullPath} to ${ROUTE_MENUS}${navItem}`);

    // Redirect to the new URL format
    return navigateTo({
      path: `${ROUTE_MENUS}${navItem}`,
      query
    }, { redirectCode: 301 }); // 301 is permanent redirect
  }
});